import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { b2bSellInConfig } from "@/lib/datasetRegistry"

// Thin config module — driven by `b2bSellInConfig` (the stock-variant of the
// shared SL shape: .xls accept, bold headings, "Dihitung server (.xls)"
// preview counts). Page-specific JSX is the breadcrumb and the
// supported-templates dropzone line. Controller renders "admin/b2b/SellIn".
export default function SellIn(props: Omit<DatasetUploadsPageProps, "config">) {
  return (
    <DatasetUploadsPage
      config={b2bSellInConfig}
      headerBanner={
        <div className="mb-2 flex items-center gap-1.5 text-xs text-ink-muted">
          <span>Data</span>
          <span>/</span>
          <span>B2B Data</span>
          <span>/</span>
          <span className="text-ink-body font-medium">B2B - Sell In</span>
        </div>
      }
      dropzoneDetail={
        <p className="mt-1 text-xs text-ink-muted">
          Template yang didukung: IDG (SellingInPM), IDM (Reguler/Safi/Skincare), Worksheet (SIL, MIDI, SAT), Sheet1 (SAT 2023)
        </p>
      }
      {...props}
    />
  )
}
